export const blFormatPrice = (
    price: string | number, 
    options?: { round?: boolean }
): string => {
    if (price === '' || price === null || typeof price === 'undefined') {
        return '';
    }

    let numericPrice = typeof price === 'string' 
        ? parseFloat(price.replace(',', '.')) 
        : price;

    if (isNaN(numericPrice)) {
        return price.toString(); 
    }

    if (options && options.round) {
        numericPrice = Math.round(numericPrice);
    }

    return new Intl.NumberFormat('sv-SE').format(numericPrice);
};